import type { FC, ReactNode } from 'react'
import type { LText } from '@/lib/localized'

type Tag = 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'div' | 'strong' | 'li' | 'td'

interface CmsTextProps {
    table: string
    id: string | null | undefined
    field: LText | null | undefined
    as?: Tag
    className?: string
}

/**
 * Renders one database text value on its own element and marks it
 * `data-mdlfy-cms="<table>:<row id>:<column>"` so it can be edited in place.
 */
export const CmsText: FC<CmsTextProps> = ({ table, id, field, as = 'span', className }): ReactNode => {
    if (!field) return null

    const Element = as

    return (
        <Element className={className} data-mdlfy-cms={id ? `${table}:${id}:${field.c}` : undefined}>
            {field.v}
        </Element>
    )
}
